'use strict';
import * as _ from 'lodash';
import { module } from '../app';

module
  .factory('MultiRadioDetailsDialogModel', [
    function () {

      function MultiRadioDetailsDialogModel(multiRadioProperty, defaultSortingPropery, title) {
        let self = this;

        self.title = title;
        self.multiRadioProperty = angular.copy(multiRadioProperty);
        self.defaultSortingPropery = defaultSortingPropery;

        self.init = async (modal, scope) => {
          self.modalInstance = modal;
          self._scope = scope;
        };

        self.geneticCouncelingMultiradioChecked = function (allOptions, option, suboption) {
          let isChecked = suboption.Value === option.Response;

          if(option.AffectAllSiblings && !isChecked){
            isChecked = !allOptions.filter(item => !item.AffectAllSiblings).some(item => item.Response !== suboption.Value);
            if(isChecked && option.Response !== suboption.Value){
              option.Response = suboption.Value;
            }
          }else if(option.AffectAllSiblings && isChecked){
            const isAnyOptionWithAnotherResponse = allOptions.filter(item => !item.AffectAllSiblings).some(item => item.Response !== suboption.Value);
            if(isAnyOptionWithAnotherResponse && option.Response === suboption.Value){
              option.Response = null;
            }
          }

          return isChecked;
        }

        self.geneticCouncelingMultiradioClick = function (allOptions, option, suboption) {
          const isUncheck = option.Response === suboption.Value;
          const responseValue = isUncheck ? '' : suboption.Value;
          if (!option.AffectAllSiblings) {
            option.Response = responseValue;
          } else {
            allOptions.forEach(item => {
              if(!isUncheck || option.Response === item.Response){
                item.Response = responseValue;
              }
            });
          }
        }

        self.ok = async () => {
          self._scope.model.isCanceled = false;
          self._scope.model.newProperty = self.multiRadioProperty;
          self.modalInstance.remove();
        }

        self.cancel = async () => {
          self._scope.model.isCanceled = true;
          self.modalInstance.remove();
        };
      }

      return MultiRadioDetailsDialogModel;
    }
  ]);



// WEBPACK FOOTER //
// ./src/scripts/models/multiRadioDetailsDialogModel.js